import React, { FC } from 'react';
import './ResultLayout.css';
import { Alert, PageLoader, ResultFilter, ResultGraph } from '../../Components';
import { useResultEnricher } from '@/Shared/Logic';
import { ActionStatusHelper, MessageHelper } from '@/Shared/Helpers';
import { FeedBackType } from '@/Shared/Types';

interface ResultLayoutProps { }

const ResultLayout: FC<ResultLayoutProps> = () => {
	const { data, filter, keyToLabelMap, chartSeries, response, handleFilterChange, userOptions, accessRight } = useResultEnricher();

	const { isLoading, isFailed } = ActionStatusHelper.is(response.status);

	if (isFailed) {
		return <Alert data={{message : response.error || 'Une erreur est survenue', type:FeedBackType.ERROR}} />;
	}

	if (isLoading || !data) {
		return <PageLoader message={MessageHelper.FETCHING.LOADING("Résultats")} />;
	}

	return (
		<div className="ResultLayout" data-testid="ResultLayout">
			<div className="ResultLayout-aside">
				<ResultFilter 
				onFilterChange={handleFilterChange} 
				filter={filter} 
				userOptions={userOptions} 
				accessRight={accessRight}
				/>
			</div>
			<div className="ResultLayout-body">
				<fieldset className='flex-row'>
					<legend>Statistiques financières (Devise)</legend>
					<ResultGraph
						keyToLabelMap={keyToLabelMap.financials}
						chartSeries={[...chartSeries.financials].map(serie => ({ ...serie, type: 'Bar' }))}
						data={data.financials} 
						title='Statistiques financières (Devise)'
					/>

					<ResultGraph
						keyToLabelMap={keyToLabelMap.financials}
						chartSeries={[...chartSeries.financials].map(serie => ({ ...serie, type: 'Line' }))}
						data={data.financials} 
						title='Statistiques financières (Devise)'
					/>


				</fieldset>
				<fieldset className='flex-row'>
					<legend>Statistiques globales (Unité)</legend>

				<ResultGraph
					keyToLabelMap={keyToLabelMap.domains}
					chartSeries={[...chartSeries.domains].map(serie => ({ ...serie, type: 'Bar' }))}
					data={data.domains}
					title='Statistiques globales (Unité)'
				/>

				<ResultGraph
					keyToLabelMap={keyToLabelMap.domains}
					chartSeries={[...chartSeries.domains].map(serie => ({ ...serie, type: 'Line' }))}
					data={data.domains}
					title='Statistiques globales (Unité)'
				/>
				</fieldset>
			</div>
		</div>
	);
}

export default ResultLayout;
